import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const APP_STORE_URL = 'https://apps.apple.com/app/id6751061434';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl"
      style={{
        background: 'rgba(5, 5, 8, 0.85)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2.5">
            <img
              src="/logo.png"
              alt="TickBoom Logo"
              className="h-8 w-auto"
            />
            <span className="text-lg font-bold tracking-tight">
              Tick<span className="gradient-text">Boom</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {[
              { label: 'Features', id: 'features' },
              { label: 'How It Works', id: 'how-it-works' },
              { label: 'Pricing', id: 'pricing' },
            ].map(({ label, id }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className="text-sm text-[rgba(255,255,255,0.45)] hover:text-white transition-colors"
              >
                {label}
              </button>
            ))}
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary px-5 py-2.5 text-sm min-h-0"
              style={{ minHeight: '38px', padding: '8px 20px', fontSize: '13px' }}
            >
              Download
            </a>
          </nav>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-[rgba(255,255,255,0.6)] hover:text-white transition-colors"
          >
            {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <nav
            className="md:hidden mt-4 pb-4 flex flex-col gap-5 border-t pt-4"
            style={{ borderColor: 'rgba(255,255,255,0.06)' }}
          >
            {[
              { label: 'Features', id: 'features' },
              { label: 'How It Works', id: 'how-it-works' },
              { label: 'Pricing', id: 'pricing' },
            ].map(({ label, id }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className="text-sm text-[rgba(255,255,255,0.5)] hover:text-white transition-colors text-left"
              >
                {label}
              </button>
            ))}
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full justify-center text-sm"
            >
              Download on App Store
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
